export const isCurrentPage = menuItem => {
  const {isSelected} = menuItem;
  const containsIsSelectedInItems = menuItem.items.some(
    item => item.isSelected,
  );

  return isSelected && !containsIsSelectedInItems;
};
